import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function OpenclawUseCases() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5566">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5567">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5568">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5569">
            An AI agent for{' '}
            <span className="text-blue-600" data-id="element-5570">every sales team</span>
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed" data-id="element-5571">
            See how B2B sales teams use Openmart to automate their top-of-funnel
            prospecting and outreach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5572">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5573">
            <div data-id="element-5574">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5575">
                SDRs & BDRs
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5576">
                SDRs use the agent to automate list building and email drafting,
                freeing up hours of manual research time every day.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5577">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5578" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5579">
                The agent does the heavy lifting of finding and scoring leads. I
                just review the drafts and hit send.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5580">
                — James T., SDR
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5581">
            <div data-id="element-5582">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5583">
                Founders & Solo Sales
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5584">
                Founders use the agent as their first SDR hire, letting it
                handle top-of-funnel while they focus on closing deals.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5585">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5586" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5587">
                It's literally like having a junior researcher on staff who
                works 24/7 and never complains.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5588">
                — Sarah M., Startup Founder
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5589">
            <div data-id="element-5590">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5591">
                Marketing Agencies
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5592">
                Agencies use the agent to quickly source highly targeted lists
                of local businesses for their clients' campaigns.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5593">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5594" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5595">
                We used to spend days building lists. Now we just describe what
                we need and get it in minutes.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5596">
                — David L., Agency Director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}